<template>
  <Dialog
    :visible="visible"
    modal
    header="T-shirt size"
    :style="{ width: '24rem' }"
    :breakpoints="{ '575px': 'calc(100vw - 2rem)' }"
    :closable="false"
    @update:visible="value => visible = value"
  >
    <div class="kb-form">
      <p class="kb-dialog-lead">
        Red shirts get a complimentary T-shirt. Which size?
      </p>
      <div class="kb-field">
        <label
          id="tshirt-size-label"
          for="tshirt-size"
        >Size</label>
        <Select
          id="tshirt-size"
          v-model="selectedSize"
          aria-labelledby="tshirt-size-label"
          :options="sizeOptions"
          option-label="label"
          option-value="value"
          placeholder="Pick a size"
          size="small"
          fluid
        />
      </div>
    </div>

    <template #footer>
      <Button
        v-if="allowSkip"
        label="Skip for now"
        text
        severity="secondary"
        class="mr-auto"
        @click="onSkip"
      />
      <Button
        label="Save"
        :disabled="!selectedSize"
        @click="onConfirm"
      />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { TSHIRT_SIZE_OPTIONS, type TshirtSize } from '~/shared/types/tshirtSize.js'

const props = defineProps<{
  modelValue: boolean
  currentSize?: TshirtSize | null
  allowSkip?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'confirm', size: TshirtSize): void
  (e: 'skip'): void
}>()

const sizeOptions = TSHIRT_SIZE_OPTIONS
const selectedSize = ref<TshirtSize | null>(props.currentSize ?? null)

// Reset selected size when dialog opens
watch(() => props.modelValue, (isVisible) => {
  if (isVisible) {
    selectedSize.value = props.currentSize ?? null
  }
})

const visible = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
})

const onConfirm = () => {
  if (selectedSize.value) {
    visible.value = false
    emit('confirm', selectedSize.value)
  }
}

const onSkip = () => {
  visible.value = false
  emit('skip')
}
</script>
